<mat-form-field appearance="fill" [formGroup]="textareaForm">
    <mat-label>{{label}}</mat-label>
    <textarea matInput placeholder={{placeholder}} 
    formControlName="mytextarea" 
    cdkTextareaAutosize
    cdkAutosizeMinRows="3"></textarea>
</mat-form-field>